module.exports = __webpack_public_path__ + "img/3.fbba57d0.png";